import { DateTime } from 'luxon';
import { translate } from '@lib-shared/helpers/translation.helper';

export class DateHelper {
  static isToday(date: DateTime): boolean {
    return date.hasSame(DateTime.utc(), 'day');
  }

  static isYesterday(date: DateTime): boolean {
    return date.hasSame(DateTime.utc().minus({ days: 1 }), 'day');
  }

  static isTomorrow(date: DateTime): boolean {
    return date.hasSame(DateTime.utc().plus({ days: 1 }), 'day');
  }

  static isSameHour(date: DateTime, compareDate: DateTime = DateTime.utc()): boolean {
    return date.hasSame(compareDate, 'hour');
  }

  static isSameYear(date: DateTime, compareDate: DateTime = DateTime.utc()): boolean {
    return date.hasSame(compareDate, 'year');
  }

  static isSameDay(date: DateTime, compareDate: DateTime): boolean {
    return date.hasSame(compareDate, 'day');
  }

  static shortDate(date: DateTime, format: string): string {
    if (this.isToday(date)) {
      return translate('Today');
    }
    if (this.isYesterday(date)) {
      return translate('Yesterday');
    }
    return date.toFormat(format);
  }

  static formattedDate(date: string): string {
    if (DateHelper.isToday(DateTime.fromISO(date))) {
      return translate('Today').toString();
    }
    if (DateHelper.isYesterday(DateTime.fromISO(date))) {
      return translate('Yesterday').toString();
    }
    if (DateHelper.isSameYear(DateTime.fromISO(date))) {
      return DateTime.fromISO(date).toLocaleString({
        day: 'numeric',
        month: 'short',
      });
    }
    return DateTime.fromISO(date).toLocaleString({ ...DateTime.DATE_MED });
  }

  static differenceInDays(date: DateTime): number {
    return Math.ceil(date.diff(DateTime.now(), 'days').toObject().days);
  }

  static relativeTime(date: DateTime): string {
    if (DateHelper.isToday(date)) {
      return translate('Today').toString();
    }
    if (DateHelper.isYesterday(date)) {
      return translate('Yesterday').toString();
    }
    if (DateHelper.isTomorrow(date)) {
      return translate('tomorrow').toString();
    }

    const daysLeft: number = DateHelper.differenceInDays(date);
    return daysLeft < 0
      ? translate('days-ago', { daysAgo: Math.abs(daysLeft) }).toString()
      : translate('days-left', { daysLeft }).toString();
  }
}
